import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { screensData } from '../../data/screensData';

const GarminGpsmap8612xsv = () => {
  // Get the product data directly from screensData
  const productId = "gpsmap-8612xsv";
  const productData = screensData.find(item => item.id === productId);
  
  console.log('GarminGpsmap8612xsv - Direct Import - Product Data:', productData);
  console.log('GarminGpsmap8612xsv - Direct Import - Image URL:', productData?.image);
  
  // Use a direct image URL if we can't find one
  const imageUrl = productData?.image || "https://www.buildmyfishfinder.com/images/screens/garmin-gpsmap-8612xsv.jpg";
  
  // Force EXACT matching only - no fuzzy matching
  return (
    <SimpleProductPage 
      specificProductId="gpsmap-8612xsv"
      productName="Garmin GPSMAP 8612xsv"
      productImage={imageUrl}
      csvLookupId="GPSMAP 8612xsv"
      csvExactMatchOnly={true}
      componentType="screen"
    />
  );
};

export default GarminGpsmap8612xsv; 